module.exports = __webpack_public_path__ + "static/media/apartment_blue.9a7a63c9.svg";